import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPageComponent } from './components/forgot-page/forgot-page.component';
import { GetStartedPageComponent } from './components/get-started-page/get-started-page.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { ResetPasswordPageComponent } from './components/reset-password-page/reset-password-page.component';
import { SignupPageComponent } from './components/signup-page/signup-page.component';
import { VerifyEmailPageComponent } from './components/verify-email-page/verify-email-page.component';
import { VerifyEmailSuccessPageComponent } from './components/verify-email-success-page/verify-email-success-page.component';
import { DefaultComponent } from './default/default.component';
import { ChannelsPageComponent } from './modules/channels-page/channels-page.component';
import { HomePageComponent } from './modules/home-page/home-page.component';
import { MessagesPageComponent } from './modules/messages-page/messages-page.component';
import { NoChannelPageComponent } from './modules/channels/no-channel-page/no-channel-page.component';
import { CreateChannelComponent } from './modules/channels/create-channel/create-channel.component';
import { SubcriptionComponent } from './modules/channels/subscription/subscription.component';
import { StroyComponent } from './modules/story/stroy/stroy.component';
import { StroyLiveComponent } from './modules/story/stroy-live/stroy-live.component';
import { StroyCameraComponent } from './modules/story/stroy-camera/stroy-camera.component';
import { NotificationsComponent } from './modules/notifications/notifications.component';
import { ProfilePageComponent } from './modules/profile/profile.component';
import { SettingsComponent } from './modules/settings/settings.component';
import { AudioCallComponent } from './modules/calling/audio-call/audio-call.component';
import { VideoCallComponent } from './modules/calling/video-call/video-call.component';
import { GroupCallComponent } from './modules/calling/group-call/group-call.component';
import { ScreenShareComponent } from './modules/calling/screen-share/screen-share.component';

const routes: Routes = [
  { path: '', component: GetStartedPageComponent},
  {
    path: 'dashboard', component: DefaultComponent,

    children: [
      {path: '', component: HomePageComponent},
      {path: 'channels', component: ChannelsPageComponent},
      {path: 'messages', component: MessagesPageComponent},
      {path: 'subscription', component: SubcriptionComponent},
      {path: 'no-channel', component: NoChannelPageComponent},
      {path: 'createchannel', component: CreateChannelComponent},
      {path: 'notifications', component: NotificationsComponent},
      {path: 'profile', component: ProfilePageComponent},
      {path: 'settings', component: SettingsComponent},
    ]
  },
  { path: 'get-started', component: GetStartedPageComponent},
  {path: 'login', component: LoginPageComponent},
  {path: 'create-account', component: SignupPageComponent},
  {path: 'forgot-password', component: ForgotPageComponent},
  {path: 'reset-password', component: ResetPasswordPageComponent},
  {path: 'verify-email', component: VerifyEmailPageComponent},
  {path: 'verification-successful', component: VerifyEmailSuccessPageComponent},
  {path: 'stories', component: StroyComponent},
  {path: 'story-live', component: StroyLiveComponent},
  {path: 'story-go-live', component: StroyCameraComponent},
  {path: 'audio-call', component: AudioCallComponent},
  {path: 'video-call', component: VideoCallComponent},
  {path: 'group-call', component: GroupCallComponent},
  {path: 'screen-share', component: ScreenShareComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
